"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Translations = require("react-platform-components/dist/Translations");
var _formFields = require("react-platform-components/dist/form-fields");
var _formik = require("formik");
var _reactRedux = require("react-redux");
var _styles = require("@material-ui/core/styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    avatar: {
      backgroundColor: '#3D7B6C',
      width: '32px',
      height: '32px'
    },
    icon: {
      fontSize: '1rem'
    },
    input: {
      width: '80px'
    }
  };
});
function Quantity(_ref) {
  var initialQuantity = _ref.initialQuantity,
    id = _ref.id,
    intl = _ref.intl;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showQuantityField = _useState2[0],
    setShowQuantityField = _useState2[1];
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.shoppingCartReducer;
    }),
    updateItemInProgress = _useSelector.updateItemInProgress;
  var formik = (0, _formik.useFormik)({
    initialValues: {
      quantity: initialQuantity
    },
    onSubmit: function onSubmit(values) {
      dispatch({
        type: 'UPDATE_ITEM_START',
        id: id,
        model: values
      });
      setShowQuantityField(false);
    }
  });
  var values = formik.values;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 8,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline",
    display: "block",
    className: "mr-2"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Quantit\xE9:",
    defaultMessage: "Quantit\xE9 :"
  }), " ", !showQuantityField && !updateItemInProgress ? initialQuantity : null), !showQuantityField && !updateItemInProgress ? /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: "ml-2",
    size: "small",
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return setShowQuantityField(!showQuantityField);
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatar,
    variant: "rounded"
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: classes.icon
  }, "edit"))) : /*#__PURE__*/_react.default.createElement(_formik.FormikProvider, {
    value: formik
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    type: "number",
    name: "quantity",
    label: intl.formatMessage({
      id: "Quantity",
      defaultMessage: "Quantity"
    }),
    size: "small",
    variant: "outlined",
    className: classes.input,
    value: values.quantity,
    onChange: formik.handleChange
  }), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    type: "submit",
    className: "ml-2",
    size: "small",
    variant: "contained",
    color: "primary",
    disabled: values.quantity < 1 ? true : false
  }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatar,
    variant: "rounded"
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: classes.icon
  }, "save")))))));
}
var _default = (0, _Translations.injectIntl)(Quantity);
exports.default = _default;